// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // apiBaseUrl: "",
  baseHref: '/',
  // domain_url: 'https://transcendentpagan.com/',
  domain_url: 'http://localhost:4200/',
  //  api_url: 'https://17nrap7g07.execute-api.us-east-1.amazonaws.com/dev/',
  api_url: 'https://luika2i934.execute-api.us-east-1.amazonaws.com/dev/',
  apiUrl_node: "https://diawjxflce.execute-api.us-east-2.amazonaws.com/dev/api/",
  apiUrl_nd: 'https://diawjxflce.execute-api.us-east-2.amazonaws.com/dev/'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
